export function toLatamDate(isoDate) {
  if (!isoDate || !isoDate.includes("-")) return isoDate || "";
  const [yyyy, mm, dd] = isoDate.split("-");
  return `${dd}/${mm}/${yyyy}`;
}

export function toIsoDate(dateValue) {
  if (!dateValue) return "";
  if (dateValue.includes("-")) return dateValue;
  if (dateValue.includes("/")) {
    const [dd, mm, yyyy] = dateValue.split("/");
    return `${yyyy}-${mm}-${dd}`;
  }
  return "";
}

export function parseDateFlexible(value) {
  if (!value) return 0;

  if (typeof value === "string" && value.includes("/")) {
    const [dd, mm, yyyy] = value.split("/");
    return new Date(`${yyyy}-${mm}-${dd}T00:00:00`).getTime();
  }

  return new Date(value).getTime() || 0;
}
